import { Dialogue } from './Dialogue.js';

/** Le tiroir de gauche d'un téléphone (`.dialogue-tiroir` du kit) : le menu. */
export function Drawer({
  open,
  onClose,
  label,
  children,
}: {
  open: boolean;
  onClose: () => void;
  label: string;
  children: React.ReactNode;
}): React.ReactElement | null {
  return (
    <Dialogue open={open} onClose={onClose} forme="tiroir" nu aria-label={label}>
      {children}
    </Dialogue>
  );
}
